module.exports = __webpack_public_path__ + "static/img/shangbiao.4859935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shangbiao.jpg
// module id = Hful
// module chunks = 1